import { createFileRoute } from "@tanstack/react-router"

import { organizationSettingsMembersViewStaticData } from "../../../../../../../views/OrganizationSettingsMembersView/constants"
import { OrganizationSettingsMembersView } from "../../../../../../../views/OrganizationSettingsMembersView/OrganizationSettingsMembersView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/organization/members")({
	component: OrganizationSettingsMembersView,
	staticData: organizationSettingsMembersViewStaticData,
})
